// removed by extract-text-webpack-plugin
module.exports = {"next":"next___2Aco7","prev":"prev___19rGl","arrow":"arrow___ZBm6_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SliderArrow/SliderArrow.scss
// module id = EDkj
// module chunks = 57